import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheCookies',
  setup(__props) {

const isOpen = ref(true)

function acceptCookie() {
  document.cookie = 'cookie=accepted'
  isOpen.value = false
}

onMounted(() => {
  const cookie = document.cookie.split('; ').find((item) => item === 'cookie=accepted')
  isOpen.value = !cookie
})

return { __sfc: true,isOpen, acceptCookie }
}

})